import React, { useEffect } from "react";
import "../../css/Rental.css";
import { useDispatch, useSelector, UseSelector } from "react-redux";
import { fetchAsyncRental, RentalUpdatedTime } from "./RentalSlice";
import { RentalInfo } from "./RentalSlice";
import TotalRental from "./total/TotalRental";
import MonthRental from "./month/MonthRental";
import MonthTransRental from "./month/MonthTransRental";
import TotalWeekRental from "./total/TotalWeekRental";
import TotalTimeRental from "./total/TotalTimeRental";
import MonthWeekRental from "./month/MonthWeekRental";
import MonthTimeRental from "./month/MonthTimeRental";
import WeekLineRental from "./week/WeekLineRental";
import WeekTimeRental from "./week/WeekTimeRental";

const Rental = () => {
  const RentalInfoData = useSelector(RentalInfo);

  const dispatch = useDispatch();

  const rentalUpdatedTime = useSelector(RentalUpdatedTime);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncRental());

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncRental());
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch]); // 依存配列にdispatchを含める

  return (
    <div className="position_row">
      <div className="dashboard_container_rental">
        <h1 className="dashboard_title_rental">利用状況 -レンタル件数-</h1>
        <div className="time_msg">※データは1分ごとに自動更新されます</div>
        <div className="dashbaord_time">最終更新時間 : {rentalUpdatedTime}</div>
        {RentalInfoData && (
          <div className="graph_container_rental">
            <div className="box_container_rental">
              <TotalRental TotalRental={RentalInfoData!.total} />
              <MonthRental
                ThisMonth={RentalInfoData!.this_month}
                LastMonth={RentalInfoData!.last_month}
              />
            </div>
            <MonthTransRental MonthTransRental={RentalInfoData!.month_rental} />
            <WeekLineRental />
            <TotalTimeRental TotalTimeRental={RentalInfoData!.total_time} />
            <TotalWeekRental TotalWeekRental={RentalInfoData!.total_week} />
            <MonthTimeRental />
            <MonthWeekRental />
            <WeekTimeRental WeekTimeRental={RentalInfoData!.week_time} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Rental;
